import React, { useEffect } from 'react';
import LastFiveShutdownTableTable from './LastFiveShutdownTable';
import TableHeader from './../data-tables/TableHeader';
import { useAppDispatch, useAppSelector } from '../../hooks/storeHooks';
import { fetchAssetDowntimeAndShutdownData } from '../../dispatchers/ShutdownDispatcher';
import { useParams } from 'react-router-dom';
import Loader from '../../features/common/Loader/Loader';
import dayjs from 'dayjs';
import useConfig from '../../hooks/useConfig';

const LastFiveShutdownWidget: React.FC = () => {
  const dispatch = useAppDispatch();
  const { assetId } = useParams<{ assetId: string }>();

  const startDate = useAppSelector((state: any) => state.AssetTrendDataSlice.startDate);
  const endDate = useAppSelector((state: any) => state.AssetTrendDataSlice.endDate);

  const wellTestData = useAppSelector((state: any) => state.WellTestIdSlice?.data || '');
  const wellTestId = useAppSelector((state: any) => state.WellTestIdSlice?.data?.WellId);

  const shutdownData = useAppSelector((state: any) => state.shutdownAndDropdownSlice?.data?.last5Shutdowns ?? []);
  const isShutdownLoading = useAppSelector((state: any) => state.shutdownAndDropdownSlice?.loading ?? false);
  const popDate = useAppSelector((state: any) => state.WellTestChartDataSlice?.popDate);

  const { isCloud } = useConfig();

  useEffect(() => {
    if (assetId && startDate && endDate) {
      const startDateStr = dayjs(startDate).format('YYYY-MM-DD HH:mm:ss.SSS');
      const endDateStr = dayjs(endDate).format('YYYY-MM-DD HH:mm:ss.SSS');
      if (wellTestId) {
        if (popDate) {
          const processedPopDate =
            !isCloud && dayjs(popDate).isValid() ? dayjs(popDate).format('YYYY-MM-DD HH:mm:ss.SSS') : '';

          dispatch(
            fetchAssetDowntimeAndShutdownData({
              assetId,
              startDate: startDateStr,
              endDate: endDateStr,
              popDate: processedPopDate,
            }),
          );
        }
      } else {
        dispatch(
          fetchAssetDowntimeAndShutdownData({
            assetId,
            startDate: startDateStr,
            endDate: endDateStr,
            popDate: '',
          }),
        );
      }
    }
  }, [assetId, startDate, endDate, popDate, isCloud, dispatch, wellTestId]);

  return (
    <main className='main-container table-wrap'>
      <TableHeader
        title={
          wellTestData?.Name && wellTestData?.Identifier
            ? `Last 5 shutdowns - ${wellTestData.Name} / ${wellTestData.Identifier}`
            : 'Last 5 shutdowns'
        }
        buttonLabel='Add Task'
      />
      {isShutdownLoading ? (
        <div className='flex justify-center items-center py-10 h-[300px]'>
          <Loader />
        </div>
      ) : shutdownData.length > 0 ? (
        <LastFiveShutdownTableTable data={shutdownData} />
      ) : (
        <div className='no-last5-shutdown-container'>
          <span className='no-matching-records-message'>No shutdown records found</span>
        </div>
      )}
    </main>
  );
};

export default LastFiveShutdownWidget;
